import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav className="breadcrumbs" style={{ marginBottom: "12px" }}>
      {items.map((item, idx) => (
        <span key={idx}>
          {item.to ? <Link to={item.to}>{item.label}</Link> : item.label}
          {idx < items.length - 1 ? " / " : ""}
        </span>
      ))}
    </nav>
  );
}
